import {withErrorHandling} from '@/domain/useCases/exceptionHandling';
import {ProviderCredentials} from '@/domain/entities/ProviderCredentials';
import updateProviderCredentialsRepository from '@/domain/repository/providerCredentialsRepository';

const updateProviderCredentials = async (
  providerCredentials: Partial<ProviderCredentials>
): Promise<ProviderCredentials | undefined> => {
  if (!providerCredentials) return;

  return withErrorHandling(
    () => updateProviderCredentialsRepository.post(providerCredentials),
    {genericErrorKey: 'providerCredentials.error'}
  );
};

export default updateProviderCredentials;
